import './ProgressApplication.css';
import React from 'react';
import { EStatus } from '../DAcApplication';
import { IconOk } from '../../atoms/Icons/';
var ProgressApplication = function ProgressApplication(_ref) {
  var rtl = _ref.rtl,
    steps = _ref.steps,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "steps-wrapper"
  }, !!steps.length && steps.map(function (_ref2, i) {
    var id = _ref2.id,
      title = _ref2.title,
      status = _ref2.status;
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      className: "step ".concat(status === EStatus.Active ? 'step--active' : status === EStatus.Completed ? 'step--completed' : ''),
      onClick: function onClick() {}
    }, /*#__PURE__*/React.createElement("div", {
      className: "step__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "step__number"
    }, status === EStatus.Completed ? /*#__PURE__*/React.createElement(IconOk, null) : i + 1), /*#__PURE__*/React.createElement("div", {
      className: "step__name"
    }, title)));
  })));
};
export default ProgressApplication;
var MAX_COMPACT_STEPS_WIDTH = '1411px';
var commonStyles = "c1ot4san";
var rtlStyles = "rf1dclo";
var ltrStyles = "livdn7v";